<div class="max-width-500 ion-padding-vertical">
  <ion-button
    fill="outline"
    color="primary"
    expand="block"
    [routerLink]="['/account/password']"
    routerDirection="root"
    routerLinkActive="active"
  >
    {{ 'account.change_password' | translate }}
  </ion-button>
  <ion-button
    fill="clear"
    expand="block"
    color="danger"
    (click)="logout()"
  >
    {{ 'account.logout' | translate }}
  </ion-button>
</div>
